export const brandingConfig = {
    copyright: {
        year: new Date().getFullYear(),
        product: "qrPON",
        tagline: "Enterprise QR Code Marketing Platform",
        company: "Sparrow Media",
        website: "sparrow.media",
        websiteUrl: "https://www.sparrow.media"
    }
};
